import { HttpErrorResponse } from '@angular/common/http';
import { MonoTypeOperatorFunction, throwError, timer } from 'rxjs';
import { retry } from 'rxjs/operators';

export function retryWithBackoff<T>(
  maxRetries = 2,
  backoffMs = 300,
): MonoTypeOperatorFunction<T> {
  return (source) =>
    source.pipe(
      retry({
        count: maxRetries,
        delay: (error, retryCount) => {
          if (error instanceof HttpErrorResponse && error.status >= 400 && error.status < 500) {
            return throwError(() => error);
          }
          const base = backoffMs * Math.pow(2, retryCount - 1);
          return timer(Math.floor(base / 2 + Math.random() * (base / 2)));
        },
      }),
    );
}
